<div class="tabs is-marginless" [class.is-boxed]="!noBorder">
  <ul>
    <div *ngFor="let tab of tabs; let i = index">
      <li [class.is-active]="isActive === i" *ngIf="!tab.hide">
        <a (click)="isActive = i; activated.emit(i)" class="weight-medium is-size-5 is-capitalized">
          <span *ngIf="!sharedTranslate">{{ tab.name | translate }}</span>
          <span *ngIf="sharedTranslate">{{ 'shared.' + tab.name | translate }}</span>
        </a>
      </li>
    </div>
  </ul>
  <ng-content select="[extra]"></ng-content>
</div>
<div class="tab-content box" [class.no-border]="noBorder">
  <ng-content select="[tab-content]"></ng-content>
</div>
